import folderIdFactory from 'owa-service/lib/factory/folderId';
import targetFolderIdFactory from 'owa-service/lib/factory/targetFolderId';
import TargetFolderId from 'owa-service/lib/contract/TargetFolderId';

/**
 * Get the context folder id used for service request
 * @param folderId the folder id
 * @return the context folder id used for service request (or null if folderId is null)
 */
export default function getServiceContextFolderId(folderId: string): TargetFolderId {
    return folderId
        ? targetFolderIdFactory({ BaseFolderId: folderIdFactory({ Id: folderId }) })
        : null;
}
